import { useState, useEffect } from "react";
import UsersApi from "../../../../Classes/API/UsersApi";
import AccountingApi from "../../../../Classes/API/AccountingApi";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import SearchUserModel from "../../../../Classes/Models/Requests/Users/SearchUser";
import SearchAccountingTherapistHourId from "../../../../Classes/Models/Requests/Accounting/SearchAccountingTherapistHourId";
import SearchPackagesReq from "../../../../Classes/Models/Requests/AccountingSessions/CreatePackageReq";
import SearchAccountingSessions from "../../../../Classes/Models/Requests/Accounting/SearchAccountingSession";

export const useAccountingData = () => {
  const [OptionUser, SetOptionUser] = useState([]);
  const [OptionPackage, SetOptionPackage] = useState([]);
  const [OptionSession, SetOptionSession] = useState([]);
  const [OptionTherapist, SetOptionTherapist] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const GetAccountingSessions = async (inputValue) => {
    const accountingSessionReqs = new SearchAccountingSessions();
    accountingSessionReqs.id = inputValue;

    const res = await SessionsApi.SearchAccountingSessions(accountingSessionReqs);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item,
        label: `ID: ${item.id}`,
      }));
    }
    return [];
  };

  const GetPackages = async (inputValue) => {
    const searchPackagesReq = new SearchPackagesReq();
    searchPackagesReq.packageName = inputValue;

    const res = await SessionsApi.SearchPackages(searchPackagesReq);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item,
        label: `ID: ${item.id} Package Name: ${item.packageName}`,
      }));
    }
    return [];
  };

  const GetUsers = async (inputValue) => {
    const usersReq = new SearchUserModel();
    usersReq.name = inputValue;

    const res = await UsersApi.SearchUsers(usersReq);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item,
        label: `${item.name}, ID: ${item.id}`,
      }));
    }
    return [];
  };

  const GetAccountingTherapistHours = async (inputValue) => {
    const accountingTherapistHourReq = new SearchAccountingTherapistHourId();
    accountingTherapistHourReq.userType = inputValue;

    const res = await AccountingApi.accountingTherapistHourId(accountingTherapistHourReq);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item.id,
        label: `ID: ${item.id}`,
      }));
    }
    return [];
  };

  const loadInitialData = async () => {
    setIsLoading(true);
    try {
      const [therapists, sessions, packages, users] = await Promise.all([
        GetAccountingTherapistHours(""),
        GetAccountingSessions(""),
        GetPackages(""),
        GetUsers(""),
      ]);

      SetOptionTherapist(therapists);
      SetOptionSession(sessions);
      SetOptionPackage(packages);
      SetOptionUser(users);
    } catch (error) {
      console.error("Error loading initial data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  return {
    OptionUser,
    OptionPackage,
    OptionSession,
    OptionTherapist,
    isLoading,
    GetAccountingSessions,
    GetPackages,
    GetUsers,
    GetAccountingTherapistHours,
  };
};